package repositories

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.engine.HttpClientEngine
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.request.get
import io.ktor.http.HttpStatusCode
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json
import practicetest.SubjectResponse
import uk.co.happyukrainians.HttpClientEngineForPlatform

class HttpClientSubjectRepository(private val engine: HttpClientEngine = HttpClientEngineForPlatform()) : SubjectRepository {
    private val client: HttpClient = HttpClient(engine) {
        install(ContentNegotiation) {
            json(Json { ignoreUnknownKeys = true })
        }
    }

    override suspend fun subjects(): Result<SubjectResponse> {
        return try {
            val httpResponse = client.get("https://api.happyukrainian.com/subjects").call.response
            if (httpResponse.status != HttpStatusCode.OK) {
                Result.failure(MainMenuRepositoryException(networkError = false))
            } else {
                Result.success(httpResponse.body<SubjectResponse>())
            }
        } catch (_: Throwable) {
            Result.failure(MainMenuRepositoryException(networkError = true))
        }
    }

}
